"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import { Debounce } from "vue-debounce-decorator";
import API from "@ym-framework/api-utils";
import OpenApiDialog from "../dialogs/OpenApiDialog.vue";
let OpenApiMain = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.serviceList = [];
    this.selectedList = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getServiceList();
    });
  }
  getServiceList() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        const response = yield API.get(`api://base.local/v2/services`);
        console.log(response.data);
        let item = _.find(response.data, { "name": "openapi" });
        if (item && item !== void 0) {
          arr.push(item);
        }
        this.serviceList = arr;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleSelectionChange(selected) {
    this.selectedList = selected;
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.getServiceList();
    });
  }
  StartService(row) {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/v2/services/${row.name}`);
        this.$message.success(this.$t("openapi.start_service_success"));
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  StopService(row) {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.local/v2/services/${row.name}`);
        this.$message.success(this.$t("openapi.start_service_stop"));
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  ShowServiceDetail(row) {
    return __async(this, null, function* () {
      yield this._open_api_dialog.open();
    });
  }
};
__decorateClass([
  Ref("open_api_dialog")
], OpenApiMain.prototype, "_open_api_dialog", 2);
__decorateClass([
  Debounce(400)
], OpenApiMain.prototype, "refresh", 1);
__decorateClass([
  Debounce(600)
], OpenApiMain.prototype, "StartService", 1);
__decorateClass([
  Debounce(600)
], OpenApiMain.prototype, "StopService", 1);
__decorateClass([
  Debounce(600)
], OpenApiMain.prototype, "ShowServiceDetail", 1);
OpenApiMain = __decorateClass([
  Component({
    components: {
      OpenApiDialog
    }
  })
], OpenApiMain);
export {
  OpenApiMain as default
};
